@if ({
  row: columnData | async,
  adata: additionData | async
  }; as $) {
  <div class="flex align-items-center">
    <div class="w-4rem">
      @if ($.row && $.adata.fetch_key && ($.row[$.adata.fetch_key] === true)) {
        <p-tag styleClass="text-xxs text-white uppercase font-normal" severity="warning">Void</p-tag>
      }
      @if ($.row && $.adata.fetch_key && ($.row[$.adata.fetch_key] === false)) {
        <p-tag severity="success" styleClass="text-xxs font-normal uppercase white-space-nowrap">Completed</p-tag>
      }
    </div>
  </div>
}
